import { j as r } from "./jsx-runtime.DGlMoOmv.js";
import * as s from "react";
const a = (o, t) => /* @__PURE__ */ r.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", viewBox: "0 0 16 16", ref: t, ...o, children: /* @__PURE__ */ r.jsx("path", { fill: "currentColor", d: "M12.396 13.104a.5.5 0 0 0 .708-.708L8.707 8l4.397-4.396a.5.5 0 0 0-.708-.708L8 7.293 3.604 2.896a.5.5 0 1 0-.708.708L7.293 8l-4.397 4.396a.5.5 0 0 0 .708.708L8 8.707l4.396 4.397Z" }) }), e = s.forwardRef(a);
export {
  e as F
};
//# sourceMappingURL=X16.DHZc2Acw.js.map
